import React from 'react';
import ServicePageLayout, { FeatureGrid, ServiceCTA } from './ServicePageLayout';
import { getService } from './serviceData';

const service = getService('cybersecurity');

const offerings = [
  { title: 'Penetration Testing', desc: 'Real-world attack simulations against your apps, networks, and infrastructure.' },
  { title: 'Security Audits', desc: 'Comprehensive reviews of your systems, configurations, and security posture.' },
  { title: 'Data Protection', desc: 'Encryption, access control, and data-handling practices that keep records safe.' },
  { title: 'Vulnerability Assessments', desc: 'Systematic scanning and prioritized remediation guidance for known weaknesses.' },
  { title: 'Recon & Threat Analysis', desc: 'Attack-surface mapping and threat intelligence to find exposure before attackers do.' },
];

// Placeholder — point at the public repo once the recon tooling is open-sourced.
const RECON_REPO_URL = 'https://github.com/tavernix';

const Cybersecurity = () => (
  <ServicePageLayout service={service} h1="Cybersecurity & Security Auditing">
    <p className="service-intro">
      Tavernix helps businesses and organizations find and fix security gaps before they become
      incidents. We combine automated tooling with hands-on manual testing using industry-standard
      tools like Metasploit and Burp Suite.
    </p>

    <FeatureGrid heading="What We Offer" features={offerings} />

    <section className="service-section">
      <h2>Open-Source Recon</h2>
      <div className="service-callout">
        <p>
          Part of our reconnaissance and threat-analysis work is powered by an open-source recon
          tool we maintain. {' '}
          <a href={RECON_REPO_URL} target="_blank" rel="noreferrer">View it on GitHub →</a>
        </p>
      </div>
    </section>

    <ServiceCTA
      heading="Know where you stand."
      blurb="Get a clear, prioritized picture of your security posture."
      label="Request a Security Audit"
      href="mailto:info@tavernix.io?subject=Request%20a%20Security%20Audit"
    />
  </ServicePageLayout>
);

export default Cybersecurity;
